export default __webpack_public_path__ + "static/media/hero.91516d15.jpeg";